import React from "react";
import { GridLegacy } from "@mui/material";
import SalesAreasWithoutVenues from "./Tables/SalesAreasWithoutVenues";
import VenuesWithOrdersWithoutSubscriptions from "./Tables/VenuesWithOrdersWithoutSubscriptions";

function SubsDashboard(props) {
  return (
    <GridLegacy container spacing={1}>
      <GridLegacy item md={6} xs={12}>
        <SalesAreasWithoutVenues />
      </GridLegacy>
      <GridLegacy item md={6} xs={12}>
        <VenuesWithOrdersWithoutSubscriptions />
      </GridLegacy>
    </GridLegacy>
  );
}

export default SubsDashboard;
